<ng-select style="height: auto"
           bindLabel="header"
           bindValue="id"
           [items]="items"
           [(ngModel)]="issue.environment"
           multiple="true"
           (change)="changeSelected($event)"
           [compareWith]="compareEntities"
           placeholder="">
</ng-select>
